import { message } from "antd";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchUserById, updateUser } from "@/lib/api/resources/users";
import { useNavigate, useParams } from "react-router-dom";
import { UserForm, UserFormValues } from "./components/UserForm";
import { Card } from "@rumbledirect/ui";

export const UserEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  if (!id) return null;

  const userQuery = useQuery({
    queryKey: ["user", id],
    queryFn: () => fetchUserById(id),
  });

  const userData = userQuery.data;
  const initialValues: UserFormValues | undefined = userData
    ? {
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        roleId: userData.role.id,
        dealershipId: userData?.dealershipCompany?.id,
      }
    : undefined;

  const mutation = useMutation({
    mutationFn: (payload: Partial<UserFormValues>) => updateUser(id, payload),
    onSuccess: () => {
      message.success("Gebruiker bijgewerkt");
      queryClient.invalidateQueries({ queryKey: ["users"] });
      queryClient.invalidateQueries({ queryKey: ["user", id] });
      navigate(`/users/${id}`);
    },
    onError: () => message.error("Bijwerken mislukt"),
  });

  const submit = (values: UserFormValues) => {
    mutation.mutate(values);
  };

  return (
    <Card
      className="max-w-xl w-full"
      title="Gebruiker bewerken"
      loading={userQuery.isLoading}
    >
      <UserForm
        initialValues={initialValues}
        loading={mutation.isPending || userQuery.isLoading}
        submitLabel="Opslaan"
        onSubmit={submit}
      />
    </Card>
  );
};
